import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { Chart } from 'chart.js';
import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PosDsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pos-ds',
  templateUrl: 'pos-ds.html',
})
export class PosDsPage {
  @ViewChild('pieChart') pieChart;

  trans_count = [];
  trans_countprev = [];
  list_date = [];
  list_date_labels = [];
  listdiv = [];
  public pieChartEl: any;
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  dash2: {};
  ondate = '';
  selectedMonth = '';
  selectedYear = '';
  months = [];
  allMonths = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' }
  ];
  years = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;

      let now = new Date();
      let cy = now.getFullYear();
      let cm = now.getMonth() + 1;

      this.selectedMonth = ('0' + cm).slice(-2);
      this.selectedYear = cy.toString();

      for (let i = cy - 3; i <= cy; i++) {
        this.years.push(i.toString());
      }

      this.updateMonths();
      this.updateOnDate();
      this.loadChart();
  }

  updateMonths() {
    let now = new Date();
    let cy = now.getFullYear();
    let cm = now.getMonth() + 1;
    let maxMonth = parseInt(this.selectedYear) === cy ? cm : 12;

    this.months = [];
    for (let i = 1; i <= maxMonth; i++) {
      let val = ('0' + i).slice(-2);
      this.months.push({ value: val, label: this.allMonths[i - 1].label });
    }

    if (parseInt(this.selectedMonth) > maxMonth) {
      this.selectedMonth = ('0' + maxMonth).slice(-2);
    }
  }

  updateOnDate() {
    this.ondate = this.selectedYear + '-' + this.selectedMonth + '-01';
  }

  changeDate() {
    this.updateMonths();
    this.updateOnDate();
    this.loadChart();
  }

  getDaysInMonth(year: number, month: number): number {
    return new Date(year, month, 0).getDate();
  }

  public loadChart()
  {

    this.showLoading();
    this.posservice.loadPOSChart(this.userid, this.token, this.serverlocation, this.global.ICNO, this.ondate)
      .then(data => {
        this.dash2 = data;
        let k : any;

        //Reset
        this.list_date = [];
        this.list_date_labels = [];
        this.listdiv = [];

        let divSet = new Set();
        let divData = {};

        for(k in this.dash2)
        {
          let namaDiv = this.dash2[k]['NamaDiv'];
          let tanggal = this.dash2[k]['Tanggal'];
          let revenue = Number(this.dash2[k]['Revenue']);

          divSet.add(namaDiv);

          if (!divData[namaDiv]) {
            divData[namaDiv] = {};
          }
          divData[namaDiv][tanggal] = revenue;
        }

        let year = parseInt(this.selectedYear);
        let month = parseInt(this.selectedMonth);
        let totalDays = this.getDaysInMonth(year, month);

        this.list_date = [];
        this.list_date_labels = [];
        for (let d = 1; d <= totalDays; d++) {
          let dateStr = this.selectedYear + '-' + ('0' + month).slice(-2) + '-' + ('0' + d).slice(-2);
          this.list_date.push(dateStr);
          this.list_date_labels.push(('0' + d).slice(-2));
        }

        let colors = [
          'rgb(54, 162, 235)',
          'rgb(255, 159, 64)',
          'rgb(153, 102, 255)',
          'rgb(75, 192, 192)',
          'rgb(255, 99, 132)',
          'rgb(255, 205, 86)',
          'rgb(201, 203, 207)',
        ];

        let datasets = [];
        let colorIndex = 0;

        divSet.forEach(namaDiv => {
          let dataPoints = this.list_date.map(d => divData[namaDiv][d] || 0);
          this.listdiv.push(namaDiv);
          let c = colors[colorIndex % colors.length];
          datasets.push({
            label: namaDiv,
            data: dataPoints,
            borderColor: c,
            backgroundColor: c.replace('rgb', 'rgba').replace(')', ', 0.2)'),
            fill: false,
            tension: 0.1,
            pointRadius: 3
          });
          colorIndex++;
        });

        this.createLineChart(datasets);
        this.loading.dismiss();
      });
  }
  createLineChart(datasets){
    if(this.pieChartEl) {
      this.pieChartEl.chart.destroy();
    }
    this.pieChartEl = new Chart(this.pieChart.nativeElement,
      {
         type: 'line',
         data: {
             labels: this.list_date_labels,
             datasets: datasets
         },
         options : {
              maintainAspectRatio: false,
              legend         : {
                display     : true
              },
              tooltips:{
                callbacks: {
                  label: function(tooltipItem, data) {
                      let label = data.datasets[tooltipItem.datasetIndex].label || '';
                      let value = Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                      });
                      return label + ': ' + value;
                  }
                }
              },
              title: {
                display: true,
                text: 'Revenue by Division'
              },
              scales: {
                  yAxes: [{
                      ticks: {
                        beginAtZero:true,
                        callback: function(label, index, labels) {
                          return Number(label).toFixed(0).replace(/./g, function(c, i, a) {
                              return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                          });
                        }
                      }
                  }],
                  xAxes: [{
                      ticks: {
                        autoSkip: false
                      }
                  }]
              }
          }
      });

      this.pieChartEl.chart.update();
  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadChart();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PosDsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-ds/pos-ds.ts